import { render, staticRenderFns } from "./UploadVectorData.vue?vue&type=template&id=160e4198&scoped=true"
import script from "./UploadVectorData.vue?vue&type=script&lang=js"
export * from "./UploadVectorData.vue?vue&type=script&lang=js"
import style0 from "./UploadVectorData.vue?vue&type=style&index=0&id=160e4198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e4198",
  null
  
)

export default component.exports